import { render, staticRenderFns } from "./ContMyDatasetsComponent.vue?vue&type=template&id=e7a23b98&scoped=true&lang=pug"
import script from "./ContMyDatasetsComponent.vue?vue&type=script&lang=js"
export * from "./ContMyDatasetsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7a23b98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e7a23b98')) {
      api.createRecord('e7a23b98', component.options)
    } else {
      api.reload('e7a23b98', component.options)
    }
    module.hot.accept("./ContMyDatasetsComponent.vue?vue&type=template&id=e7a23b98&scoped=true&lang=pug", function () {
      api.rerender('e7a23b98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/my_objects/components/ContMyDatasetsComponent.vue"
export default component.exports